export const SURFACE_CONTEXT = Object.freeze({
  Web: 'web',
  InAppInline: 'in_app_inline',
  InAppInterstitial: 'in_app_interstitial',
});

export const SURFACE_INITIAL = Object.freeze({
  Allocated: 'allocated',
  Content: 'content',
  Viewport: 'viewport',
});

export const SURFACE_INTERACTION = Object.freeze({
  Fixed: 'fixed',
  ExpandPush: 'expand_push',
  ExpandOverlay: 'expand_overlay',
});

export const SURFACE_RESULT = Object.freeze({
  Resized: 'resized',
  LocalOverlay: 'local_overlay',
  Expanded: 'expanded',
  Collapsed: 'collapsed',
  Failed: 'failed',
});

/** Product guardrail for vertically flowing inline units. */
export const MAX_FLOW_SURFACE_HEIGHT_PX = 10_000;
/** Content surfaces are responsive down to a practical mobile/article width. */
export const MIN_CONTENT_SURFACE_WIDTH_PX = 280;

/** Shared DOM hand-off between Neuronic and Lucid. */
export const SURFACE_CLIENT_SYMBOL = Symbol.for('neuronic.surface-client.v1');

export function isPositiveSize(size) {
  return !!size
    && Number.isFinite(size.width)
    && Number.isFinite(size.height)
    && size.width > 0
    && size.height > 0;
}

export function sizeFits(available, required) {
  return isPositiveSize(available)
    && isPositiveSize(required)
    && available.width >= required.width
    && available.height >= required.height;
}

export function contentSize(content) {
  return { width: content.w, height: content.h };
}
